import { Dispatch, SetStateAction } from 'react';
import { useDispatch } from 'react-redux';
import welcomeImage from '../../assets/images/backoffice/MavieWelcome.png';
import welcomeImage2 from '../../assets/images/backoffice/stakingHubNft.png';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { H2, H4, P2 } from '../../styles/FontStyles';
import { Button } from '../../styles/GlobalComponents';
import { colors, globalImages } from '../../styles/GlobalStyles';
import { Icon, IconCheck } from '../../styles/Icons';
import { FlexCenter } from '../../styles/stylesStyled';
import { checkSideModal } from './Dashboard.actions';
import { PROJECT_NAME } from '../../helpers/helperFunctions';

interface WelcomeSidebarProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export const WelcomeSidebar = ({ open, setOpen }: WelcomeSidebarProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation('dashboard');

  const clickBuy = () => {
    dispatch(checkSideModal(history));
  };

  const welcomeData = [
    'Exclusive opportunities and presale offers.',
    `Unprecedented earning potential for ${PROJECT_NAME} partners`,
    `Reliable customer support and partner resources`,
    'Secure, trusted personal finances dashboard',
    'Tickets to exclusive events to meet and hang with G.O.A.T.s'
  ];

  return (
    <SidebarModal
      isOpen={open}
      setOpen={setOpen}
      sidebarWidth={'508px'}
      hasCloseButton={false}
      overlayClose={true}>
      <img
        style={{ width: '100%' }}
        src={globalImages.authLayoutLogo}
        alt='welcome'
      />
      <H2 m='40px 0'>Welcome to {PROJECT_NAME}</H2>
      <H4 m='20px 0'>Start With {PROJECT_NAME} Back Office</H4>

      {welcomeData.map((data, i) => (
        <FlexCenter key={i} style={{ gap: 15, margin: '20px 0' }}>
          <Icon>
            <IconCheck />
          </Icon>
          <P2 color={colors.neutral700}>{data}</P2>
        </FlexCenter>
      ))}
      <Button onClick={clickBuy}>{t('welcome.start_here')}</Button>
      <Button onClick={() => setOpen(false)} textButton>
        {t('welcome.maybe_later')}
      </Button>
    </SidebarModal>
  );
};
